import {
  AMOUNT_BASED_BONUS,
  CURRENCIES,
  ENV_PRODUCTION,
  REFERRAL_BONUS,
  REWARDS_LOYALTY_BOOSTER,
  REWARDS_TIME_BOOSTER,
  REWARDS_TIME_THRESHOLD,
  TIME_BASED_BONUS
} from '../constants/app'
import { formatOrdinal } from './numbers.helpers'

const isEnvProduction = () => {
  return process.env.REACT_APP_ENV === ENV_PRODUCTION
}

const getTimeNow = () => {
  return Math.floor(Date.now() / 1000)
}

const isSaleEnded = () => {
  return getTimeNow() >= getContractConfig().end
}

const openBlankRedirectPage = (url) => {
  window.open(url, '_blank')
}

const checkLoyaltyBooster = (nftCount) => {
  if (nftCount >= 20) return REWARDS_LOYALTY_BOOSTER[20]
  if (nftCount >= 10) return REWARDS_LOYALTY_BOOSTER[10]
  if (nftCount >= 3) return REWARDS_LOYALTY_BOOSTER[3]
  if (nftCount >= 1) return REWARDS_LOYALTY_BOOSTER[1]
}

const getMinutesFromStartTime = () => {
  const differenceInMillis = Math.abs(getTimeNow() - getContractConfig().end)
  const differenceInMinutes = differenceInMillis / 60
  return differenceInMinutes
}

const checkTimeBooster = (minutes) => {
  if (minutes <= REWARDS_TIME_THRESHOLD.FIRST)
    return {
      key: REWARDS_TIME_THRESHOLD.FIRST,
      value: REWARDS_TIME_BOOSTER[REWARDS_TIME_THRESHOLD.FIRST]
    }
  if (minutes <= REWARDS_TIME_THRESHOLD.SECOND)
    return {
      key: REWARDS_TIME_THRESHOLD.SECOND,
      value: REWARDS_TIME_BOOSTER[REWARDS_TIME_THRESHOLD.SECOND]
    }
  if (minutes <= REWARDS_TIME_THRESHOLD.THIRD)
    return {
      key: REWARDS_TIME_THRESHOLD.THIRD,
      value: REWARDS_TIME_BOOSTER[REWARDS_TIME_THRESHOLD.THIRD]
    }
  if (minutes > REWARDS_TIME_THRESHOLD.THIRD)
    return {
      key: REWARDS_TIME_THRESHOLD.FOURTH,
      value: REWARDS_TIME_BOOSTER[REWARDS_TIME_THRESHOLD.FOURTH]
    }
}

const copyToClipboard = (data) => {
  const apiKeySelection = document.createElement('textarea')
  apiKeySelection.value = data
  document.body?.appendChild(apiKeySelection)
  apiKeySelection.select()
  document.execCommand('copy')
  document.body?.removeChild(apiKeySelection)
}

const truncateTextForHash = (text) => {
  if (!text) {
    return ''
  }
  return `${text.substring(0, 6)}...${text.substring(text.length - 4)}`
}

const buildLeaderboardBonusLabel = (t, key) => {
  if (key.includes('_')) {
    const [from, to] = key.split('_')
    return t('home.from-to-place', {
      from: formatOrdinal(from),
      to: formatOrdinal(to)
    })
  }
  return t('home.place', { value: formatOrdinal(key) })
}

const getTimeBasedKey = (time) => {
  return Object.keys(TIME_BASED_BONUS).find((key) => time?.[key]) || 0
}

const getAmountBasedLabelSum = (amount) => {
  const result = {
    label: [],
    value: 0
  }
  if (amount) {
    Object.keys(AMOUNT_BASED_BONUS).forEach((key) => {
      if (Object.keys(amount).includes(key)) {
        result.value += AMOUNT_BASED_BONUS[key]
        result.label.push(`+${key} ${CURRENCIES.DEFAULT}`)
      }
    })
  }
  return result
}

const getReferralBasedLabelSum = (ref) => {
  const result = {
    label: [],
    value: 0
  }
  if (ref) {
    Object.keys(REFERRAL_BONUS).forEach((key) => {
      if (Object.keys(ref).includes(key)) {
        result.value += REFERRAL_BONUS[key]
        result.label.push(`${key} wallets`)
      }
    })
  }
  return result
}

const formatDecimalMinutes = (decimalMinutes) => {
  const minutes = Math.floor(decimalMinutes)
  const seconds = Math.round((decimalMinutes - minutes) * 60)
  return `${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`
}

const getContractConfig = () => {
  const contractConfig = process.env.REACT_APP_CONTRACT_CONFIG
  return contractConfig
    ? JSON.parse(contractConfig)
    : {
        address: '',
        start: 0,
        end: 0
      }
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export {
  getTimeNow,
  isEnvProduction,
  isSaleEnded,
  openBlankRedirectPage,
  checkLoyaltyBooster,
  getMinutesFromStartTime,
  checkTimeBooster,
  copyToClipboard,
  truncateTextForHash,
  buildLeaderboardBonusLabel,
  getTimeBasedKey,
  getAmountBasedLabelSum,
  getReferralBasedLabelSum,
  formatDecimalMinutes,
  getContractConfig,
  scrollToTop
}
